import React, { SyntheticEvent, useState } from 'react';
import ReactDOM from 'react-dom';
import { IconButton, Snackbar as MUISnackbar, SnackbarCloseReason, SnackbarContent } from '@material-ui/core';
import { IUseSnackbar } from './snackbar.interface';
import { CheckCircle, Close, Error, Info, Warning } from '@material-ui/icons';
import clsx from 'clsx';
import { useStyles } from './styles';

export const useSnackbar = () => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const [type, setType] = useState<IUseSnackbar['type']>('error');
  const [duration, setDuration] = useState(5000);
  const [message, setMessage] = useState('');
  const variantIcon = {
    error: Error,
    info: Info,
    success: CheckCircle,
    warning: Warning
  };
  const Icon = variantIcon[type];

  const handleClose = (_: SyntheticEvent<unknown, Event>, reason: SnackbarCloseReason) => {
    if (reason === 'clickaway') {
      return;
    }
    setIsOpen(false);
  };

  const handlePortals = (children: React.ReactNode) => {
    const el = document.getElementById('root-snackbar') as HTMLElement;
    return ReactDOM.createPortal(children, el);
  };

  const Snackbar = () =>
    handlePortals(
      <MUISnackbar
        open={isOpen}
        onClose={handleClose}
        autoHideDuration={duration}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'bottom'
        }}
      >
        <SnackbarContent
          className={clsx(classes[type], classes.close)}
          message={
            <span className={classes.message}>
              <Icon className={clsx(classes.icon, classes.iconVariant)} />
              {message}
            </span>
          }
          action={[
            <IconButton key="close" color="inherit" onClick={() => setIsOpen(false)}>
              <Close className={classes.icon} />
            </IconButton>
          ]}
        />
      </MUISnackbar>
    );

  const handleToggle = (args: IUseSnackbar) => {
    const { duration: durationArgs, message, type } = args;
    setType(type);
    setDuration(durationArgs || duration);
    setMessage(message);
    setIsOpen(!isOpen);
  };

  return {
    Snackbar,
    toggleSnackbar: (args: IUseSnackbar) => handleToggle(args)
  };
};
